import React from "react";
import { BrowserRouter, Routes, Route } from "react-router";
import { FormProvider } from "react-hook-form";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/ja";
import theme from "src/styles/theme";
import { useFormController } from "src/hooks/form";
import Layout from "src/components/Layout";
import MaintenanceModal from "src/components/MaintenanceModal";
import TopPage from "src/pages/top";
import ConfirmPage from "src/pages/confirm";
import ResultForInvestmentPage from "src/pages/result/investment";
import ResultForResidencePage from "src/pages/result/residence";
import InputPersonalPage from "src/pages/input_personal";
import InputPropertyPage from "src/pages/input_property";

dayjs.locale("ja");

export default function App() {
  const methods = useFormController();

  // 実行時に /lp-2nd 配下だった場合は/lp-2nd配下のまま表示
  const basename = React.useMemo(() => {
    return window.location.pathname.startsWith("/lp-2nd") ? "/lp-2nd" : "/";
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
        <FormProvider {...methods}>
          <BrowserRouter basename={basename}>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<TopPage />} />
                <Route path="input_property" element={<InputPropertyPage />} />
                <Route path="input_personal" element={<InputPersonalPage />} />
                <Route path="confirm" element={<ConfirmPage />} />
                <Route path="result/investment" element={<ResultForInvestmentPage />} />
                <Route path="result/residence" element={<ResultForResidencePage />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <MaintenanceModal open={true} />
        </FormProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}
